<template>
  <div :class="$style.cd">
    <div :class="$style.wrap" :style="{ 'animation-play-state': playing ? 'running' : 'paused' }">
      <div :class="$style.cdBody">
        <div :class="$style.hole"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CD',
  computed: mapState(['playing'])
}
</script>

<style lang="scss" module>
$cdSize: 180px;

.cd {
  height: 256px;
  width: 256px;
  display: flex;
  justify-content: center;
  background: url('./assets/shadow.svg') no-repeat 50% 100%;
}

.wrap {
  width: $cdSize;
  height: $cdSize;
  margin-top: 26px;
  border-radius: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #76B6FD 0%, #417FF9 100%);
  animation: Rotate 10s linear infinite;
  overflow: hidden;

  &::before {
    content: '';
    width: 139px;
    height: 100px;
    position: absolute;
    bottom: -3px;
    right: -15px;
    background: url('./assets/icon.png') no-repeat;
    background-size: contain;
  }
}

.hole {
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    width: 27px;
    height: 27px;
    background-color: #fff;
    border-radius: 100%;
  }
}

:global {
  @keyframes Rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
